import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component

import { ColDef, ValueFormatterParams } from 'ag-grid-community';
import { TSummaryDcf, TSummaryDcfItem } from '../dcfTypes';
import { useMemo, useRef } from 'react';
import { formatValueAsString } from '../../../utils/helpers';
import InfoNote from '../../common/SharedComponents/Info-Note';
import { themeBalham } from 'ag-grid-enterprise';
import DynamicTab from '../../../shared/components/tabs/DynamicTab';

export interface ISummaryDcf {
	summaryDcf: TSummaryDcf | null;
}

const SummaryDcf: React.FC<ISummaryDcf> = ({ ...props }) => {
	const gridRef = useRef<any>(null);

	const onGridReady = (params: any) => {
		gridRef.current = params.api;
		gridRef.current!.sizeColumnsToFit();
	};
	
	const options: Intl.NumberFormatOptions = { minimumFractionDigits: 0, maximumFractionDigits: 1 };

	const rowData = props.summaryDcf?.dataList ? props.summaryDcf.dataList : [];

	const defaultColDef = useMemo<ColDef>(() => {
		return {
			flex: 1,
			// filter: 'agTextColumnFilter',
		};
	}, []);

	const colDefs: ColDef<TSummaryDcfItem>[] = [
		{
			headerName: '# Sector',
			field: 'sector',
			cellStyle: (params) =>
				params.value === 'Total'
					? { backgroundColor: '#eeeeee', fontWeight: 'bold', color: 'black' }
					: { backgroundColor: '#eeeeee', fontWeight: 'normal', color: 'black' },
			aggFunc: () => 'Total',
		},
		{
			headerName: '# Ships',
			field: 'ships',
			valueFormatter: (params: ValueFormatterParams<TSummaryDcfItem, any>) => formatValueAsString(params.value),
		},
		{
			headerName: 'Average Size',
			field: 'averageSize',
			valueFormatter: (params: ValueFormatterParams<TSummaryDcfItem, any>) =>
				formatValueAsString(params.value, options, '', '', ' ' + params.data?.sizeUnit),
		},
		{
			headerName: 'Average Age',
			field: 'averageAge',
			valueFormatter: (params: ValueFormatterParams<TSummaryDcfItem, any>) => formatValueAsString(params.value, options),
		},
		{
			headerName: 'Current DCF ($ Mn)',
			field: 'dcfValue',
			cellStyle: { backgroundColor: '#df6721', color: 'white' },
			valueFormatter: (params: ValueFormatterParams<TSummaryDcfItem, any>) => formatValueAsString(params.value, options),
			aggFunc: () => {
				const totalDCFValue = rowData.reduce(
					(sum, vessel) => sum + (!Number.isNaN(vessel.dcfValue) ? vessel.dcfValue : 0),
					0,
				);
				return totalDCFValue;
			},
		},
	];


	const tabs = useMemo(
		() => [
			{
				id: 'overview',
				label: 'Overview',
				content: (
					<div className="flex flex-col w-full h-full">
						<div className="w-full h-full">
							<AgGridReact
								ref={gridRef}
								onGridReady={onGridReady}
								columnDefs={colDefs}
								rowData={rowData}
								theme={themeBalham}
								defaultColDef={defaultColDef}
								grandTotalRow="bottom"
							/>
						</div>
						<div className="mt-4">
							<InfoNote />
						</div>
					</div>
				),
			},
		],
		[rowData, colDefs],
	);

	return <DynamicTab items={tabs} tabColor="msi-chart-orange" />;
};

export default SummaryDcf;
